import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { ISubscriptionPlan } from 'app/shared/model/subscription-plan.model';
import { getEntities as getSubscriptionPlans } from 'app/entities/subscription-plan/subscription-plan.reducer';
import { getEntity, updateEntity, createEntity, reset } from './subscription-plan-specification.reducer';
import { ISubscriptionPlanSpecification } from 'app/shared/model/subscription-plan-specification.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/updateSuccessshared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface ISubscriptionPlanSpecificationUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const SubscriptionPlanSpecificationUpdate = (props: ISubscriptionPlanSpecificationUpdateProps) => {
  const [subscriptionPlanId, setSubscriptionPlanId] = useState('0');
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { subscriptionPlanSpecificationEntity, subscriptionPlans, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/subscription-plan-specification');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getSubscriptionPlans();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...subscriptionPlanSpecificationEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.subscriptionPlanSpecification.home.createOrEditLabel">Create or edit a SubscriptionPlanSpecification</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : subscriptionPlanSpecificationEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="subscription-plan-specification-id">ID</Label>
                  <AvInput id="subscription-plan-specification-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="specificationNameLabel" for="subscription-plan-specification-specificationName">
                  Specification Name
                </Label>
                <AvField id="subscription-plan-specification-specificationName" type="text" name="specificationName" />
              </AvGroup>
              <AvGroup>
                <Label id="createdOnLabel" for="subscription-plan-specification-createdOn">
                  Created On
                </Label>
                <AvField id="subscription-plan-specification-createdOn" type="date" className="form-control" name="createdOn" />
              </AvGroup>
              <AvGroup>
                <Label for="subscription-plan-specification-subscriptionPlan">Subscription Plan</Label>
                <AvInput
                  id="subscription-plan-specification-subscriptionPlan"
                  type="select"
                  className="form-control"
                  name="subscriptionPlan.id"
                >
                  <option value="" key="0" />
                  {subscriptionPlans
                    ? subscriptionPlans.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.id}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/subscription-plan-specification" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  subscriptionPlans: storeState.subscriptionPlan.entities,
  subscriptionPlanSpecificationEntity: storeState.subscriptionPlanSpecification.entity,
  loading: storeState.subscriptionPlanSpecification.loading,
  updating: storeState.subscriptionPlanSpecification.updating,
  updateSuccess: storeState.subscriptionPlanSpecification.updateSuccess,
});

const mapDispatchToProps = {
  getSubscriptionPlans,
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlanSpecificationUpdate);
